import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSnackbar } from '../../../../reusable-components/snackbar';

ShippingIcon.propTypes = {
  row: PropTypes.object,
};

export default function ShippingIcon({ row }) {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const itemTrackingLinks = (row) => (
    <>
      {row?.itemShips
        ?.filter((itemShip) => itemShip.trackingUrl)
        .flatMap((itemShip) =>
          itemShip.trackingNumber?.split(',').map((trackingNumber, index, arr) => (
            <span key={`${itemShip.trackingUrl}-${trackingNumber}`}>
              <a
                href={itemShip.trackingUrl + trackingNumber.trim()}
                target="_blank"
                rel="noreferrer"
                style={{ color: '#fff' }}
              >
                {trackingNumber.trim()}
              </a>
              {index < arr.length - 1 && ', '}
            </span>
          ))
        )}
      {row?.itemShips
        ?.filter((itemShip) => !itemShip.trackingUrl)
        .flatMap((itemShip, index) =>
          itemShip.trackingNumber?.split(', ').map((trackingNumber) => (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ '&:hover': { cursor: 'copy' } }}
              key={index}
              onClick={() => {
                navigator.clipboard.writeText(trackingNumber);
                enqueueSnackbar(`Copied ${trackingNumber} to clipboard`);
              }}
            >
             {itemShip.sentFrom ? `${itemShip.sentFrom}:` : ' '}
              {trackingNumber || 'Tracking unavailable'}
                <ContentCopyIcon sx={{ color: 'secondary.main', fontSize: 14 }} />
            </Grid>
          ))
        )}
    </>
  );

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          title={row?.approved === false ? "" : row?.statusUpdates?.some(status =>
            status.updatedBy?.toLowerCase()?.includes('ship')) ?
              itemTrackingLinks(row):
              (row.vendorInfo?.sendsShipping ? `Awaiting Shipping Confirmation` :
                `No Tracking Expected`)}
          disableHoverListener={row?.deleted === true}
          PopperProps={{ disablePortal: false }}
          onClose={handleTooltipClose}
        >
          <IconButton disableRipple edge="end" onClick={handleTooltipOpen}>
            <LocalShippingIcon sx={{ ml: 0.5, fontSize: '1.00rem' }} color={row?.statusUpdates?.some(status =>
              status.updatedBy?.toLowerCase()?.includes('ship')) ? "secondary" : "grey"}/>
          </IconButton>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
}
